import { basicClient } from "../http/httpClient";

export interface CepServiceResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  erro: string;
}

export const cepService = async (cep: string) => {
  const { data } = await basicClient.get<CepServiceResponse>(
    `https://viacep.com.br/ws/${cep}/json/`,
  );

  return data;
};
